export default "__VITE_ASSET__CYK1$NK$__"